import { Moment } from 'moment';
import CommonFilters from '@/shared/models/CommonFilters';
import WorkPreparationOptions from './WorkPreparationOptions';

export default class WorkPreparationFilters {
  constructor(
    readonly commonFilters: CommonFilters,
    readonly plannedFrom: Moment,
    readonly plannedTill: Moment,
    readonly options: WorkPreparationOptions,
  ) {}
}